<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head"></Head>
    <div v-if="isMaxScreen" class="pc_who-are-we-container">
      <div class="top-container">
          <img src="../../assets/image/eu-home/pc-who-are-we-banner.png" alt="" class="banner-image">
        <div class="mosha-box">
          <div class="text">{{$t('home.whoAreWe.646u995ltgw0')}}</div>
          <div class="text">{{$t('home.whoAreWe.646u995lv9g0')}}</div>
        </div>

      </div>
      <div class="bottom-container">
        <div class="text-box">
          <div class="text">{{$t('home.whoAreWe.646u9d5lv9g0')}}</div>
          <div class="text">{{$t('home.whoAreWe.646u995dv9g0')}}</div>
          <div class="text">{{$t('home.whoAreWe.646u99slv9g0')}}</div>
        </div>
          <img src="../../assets/image/eu-home/pc-who-are-we-pic.png" alt="" class="bottom-image">
      </div>

    </div>
    <div v-else class="who-are-we-container">
      <div class="top-container">
          <img src="../../assets/image/eu-home/mb-who-are-we-banner.png" alt="" class="banner-image">
        <div class="mosha-box">
          <div class="text">{{$t('home.whoAreWe.646u995ltgw0')}}</div>
          <div class="text">{{$t('home.whoAreWe.646u995lv9g0')}}</div>
        </div>

      </div>
      <div class="bottom-container">
        <div class="text-box">
          <div class="text">{{$t('home.whoAreWe.646u9d5lv9g0')}}</div>
          <img src="../../assets/image/eu-home/mb-who-are-we-pic1.png" alt="" class="bottom-image">
          <div class="text">{{$t('home.whoAreWe.646u995dv9g0')}}</div>
          <img src="../../assets/image/eu-home/mb-who-are-we-pic2.png" alt="" class="bottom-image">
          <div class="text">{{$t('home.whoAreWe.646u99slv9g0')}}</div>
          <img src="../../assets/image/eu-home/mb-who-are-we-pic3.png" alt="" class="bottom-image">
        </div>
      </div>

    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isES } from '@/locales';
import Head from '../../components/head'
import Bottom from '../../components/bottom'
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  data () {
    return {
      isES
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
      isEn(){
        return true
      }
    })
  },
  mounted(){
    window.scrollTo(0, 0);
  },
  methods: {
    handleClick(){
      this.$refs.head.hidLangeList();
    }
  }
}
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  // PC端
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #FFF;
    font-family: "PingFang SC";
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .pc_who-are-we-container{
      padding-top: 100px;

      .top-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        padding-bottom: 100px;
        .banner-image{
          width: 100%;
        }
        .mosha-box{
          position: absolute;
          bottom: 0;
          width: 1400px;
          margin: auto;
          height: 326px;
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.20);
          backdrop-filter: blur(10px);

          .text{
            margin-left: 48px;
            color: #FF9600;
            font-family: "PingFang SC";
            font-size: 120px;
            font-weight: 500;
          }
        }

      }
      .bottom-container{
        padding: 20px 0 120px;
        max-width: 1400px;
        margin: auto;
        .text-box{
          width: 100%;
          .text{
            color: #252629;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; 
            margin-bottom: 32px;

          }
        }
        .bottom-image{
          width: 100%;
        }

      }

    }
  }
}
@media (max-width: 980px) {
  // 移动端
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #FFF;
    font-family: "PingFang SC";
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .who-are-we-container{
      padding-top: 100px;

      .top-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        padding-bottom: 140px;
        .banner-image{
          width: 100%;
        }
        .mosha-box{
          position: absolute;
          bottom: 0;
          width: calc(100% - 108px);
          height: 224px;
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.20);
          backdrop-filter: blur(20px);

          .text{
            margin-left: 44px;                 
            color: #FF9600;
            font-family: "PingFang SC";
            font-size: 64px;
            font-style: normal;
            font-weight: 600;
            line-height: 150%;
          }
        }

      }
      .bottom-container{
        padding: 20px 30px 16px;
        width: calc(100% - 60px);
        .text-box{
          .text{
            color: #252629;
            font-family: "PingFang SC";
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;

          }
        }
        .bottom-image{
          width: 100%;
          padding: 32px 0 48px;
        }

      }

    }
  }

}
</style>
